import { defineMessages } from '@alltrails/shared/react-intl';

const COLLAGE_ALTS = defineMessages({
  IMG_0: {
    defaultMessage: 'Two hikers jumping over a small creek one at a time in the middle of a forest'
  },
  IMG_1: {
    defaultMessage: 'An adult and a child hiking over a small red rock'
  },
  IMG_2: {
    defaultMessage: 'Two adults walking their mountain bikes over a small wooden bridge'
  },
  IMG_3: {
    defaultMessage: 'Two adults walking a dog on a leash in a field of rolling hills'
  },
  IMG_4: {
    defaultMessage: 'An adult running on a dirt track with a mountainous field in the background'
  }
});

export default COLLAGE_ALTS;
